var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0C36.479 0 47 10.521 47 23.5C47 36.479 36.479 47 23.5 47C10.521 47 0 36.479 0 23.5C0 10.521 10.521 0 23.5 0ZM23.5 9.4C22.8767 9.4 22.279 9.64759 21.8383 10.0883C21.3976 10.529 21.15 11.1267 21.15 11.75V23.5C21.1501 24.1232 21.3978 24.7208 21.8386 25.1614L28.8885 32.2114C29.3318 32.6395 29.9254 32.8764 30.5415 32.871C31.1577 32.8657 31.7471 32.6185 32.1828 32.1828C32.6185 31.7471 32.8657 31.1577 32.871 30.5415C32.8764 29.9254 32.6395 29.3318 32.2114 28.8885L25.85 22.5271V11.75C25.85 11.1267 25.6024 10.529 25.1617 10.0883C24.721 9.64759 24.1233 9.4 23.5 9.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLengthIcon);
export default __webpack_public_path__ + "static/media/course_length_icon.105c7859cabe08681997d45f1f21caf3.svg";
export { ForwardRef as ReactComponent };